<template>
    <div class="custom-question-form-wrapper">
        <Select
            class="custom-question-form-type-select"
            :config="{ initLabel: value.formName || '' }"
            :initValue="initFormId"
            :topOrBottom="86"
            :options="fromTypeOption"
            @menuClick="formSelected"
        >
            <Search :placeholder="formSelectedLabel" @searchChange="searchChange" @inputChange="searchChange" class="scene-search" />
        </Select>
        <ErrorMessage v-show="!isValid" :message="message" />
    </div>
</template>

<script>
import Select from "@/views/zhiji/bComponents/inputs/Select";
import Search from "@/views/zhiji/bComponents/inputs/Search";
import ErrorMessage from "./ErrorMessage";
import { debounce } from "@/views/zhiji/js/common/util.js";
import { queryFormList } from "@/views/zhiji/js/services/service.js";
import { objectFieldNotEq, objectRequiredField, checkRule } from "../rules.js";
import Validation from "../validation.js";

export const notEqDefValidator = { field: "formId", compare: "def", validator: objectFieldNotEq };
export const requiredValidator = { fields: ["formId"], validator: objectRequiredField };

export default {
    name: "QuestionForm",
    components: {
        Select,
        Search,
        ErrorMessage,
    },
    props: ["value", "widget", "rules", "validation"],
    data() {
        return {
            formDatas: [],
            isValid: true,
            message: "",
            myValidation: null
        };
    },
    created() {
        this.myValidation = new Validation({
            tiggerHanlder: () => this.validate(this.value),
            propName: this.widget && this.widget.name
        });
        this.validation && this.validation.addChild(this.myValidation);
        this.searchHanlder = debounce(data => {
            let searchField = data[0];
            this.searchByFormName(searchField);
        }, 500);
        this.searchHanlder({ value: "" });
    },
    destroyed() {
        this.myValidation && this.myValidation.destroy();
    },
    computed: {
        props() {
            return this.widget.props;
        },
        initFormId() {
            return this.value.formId || "def";
        },
        fromTypeOption() {
            const formTypeOption = [...this.formDatas];
            // 添加默认状态
            formTypeOption.unshift({
                label: this.$t("zhiji.answer.selectFormType"),
                value: "def"
            });
            return formTypeOption;
        },
        formSelectedLabel() {
            return this.$t("zhiji.common.inputHolderLabel");
        },
        isError() {
            return this.verifyInfo && this.verifyInfo.isValid === false;
        }
    },
    methods: {
        formSelected(data) {
            const newWidget = {
                formId: data.value + "",
                formName: data.label
            };
            this.$emit("change", newWidget);
            this.validate(newWidget);
            this.emitValid();
        },
        searchChange(data) {
            this.searchHanlder(data);
        },
        searchByFormName(data) {
            queryFormList({
                page: 1,
                size: 10,
                status: 1, // 只关联正常状态的表单
                keyword: data.value
            }).then(data => {
                this.formDatas = data.dataset.map(item => {
                    return {
                        label: `${item.firstTag} > ${item.secondTag} > ${item.name}`,
                        value: item.rowId
                    };
                });
            });
        },
        validate(newValue) {
            const required = (this.rules || []).some(rule => rule.required);
            if (!required) {
                return;
            }
            const result = checkRule(newValue, [notEqDefValidator, requiredValidator]);
            this.isValid = result.isValid;
            if (!this.isValid) {
                this.message = "请输入必要内容";
            }
            return {
                isValid: this.isValid,
                message: this.message
            };
        },
        emitValid() {
            this.myValidation && this.myValidation.emit({ isValid: this.isValid, message: this.message });
        }
    }
};
</script>

<style scoped lang="less">
.custom-question-form-wrapper {
    position: relative;
    width: 350px;
    padding: 14px;
    border-radius: 8px;
    background: #f2f7fb;
    .custom-question-form-type-select {
        width: 100%;
        color: #9b9ba3;
        background: #fff;
        .scene-search {
            width: 100%;
            position: absolute;
            left: 0;
            top: 42px;
            padding: 7px 0;
            background: #fff;
            z-index: 1;
        }
    }
}
</style>
